// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useMaximumScreenBrightness = (_shouldApply: boolean = true) => {};
